import { Fragment } from "react";
import { Divider, Text } from "react-native-paper";
import type { IconType } from "../../../../icon";
import { useAppTheme } from "../../../../useAppTheme";
import { AppIcon } from "../../../AppIcon";
import Box from "../../../Box";

export type IconBulletItem = {
	icon: IconType;
	text: string;
};

type Props = {
	items: IconBulletItem[];
	withDividers?: boolean;
};

export const IconBulletList = ({ items, withDividers = true }: Props) => {
	const theme = useAppTheme();

	return (
		<Box gap={16}>
			{items.map((item, index) => (
				<Fragment key={`${item.icon}-${index}`}>
					{withDividers && index > 0 ? <Divider /> : null}
					<Box flexDirection="row" alignItems="flex-start" gap={8}>
						<AppIcon name={item.icon} size={24} color={theme.colors.primary} />
						<Text variant="bodyLarge" style={{ flex: 1 }}>
							{item.text}
						</Text>
					</Box>
				</Fragment>
			))}
		</Box>
	);
};
